import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';

const publicUrl = process.env.PUBLIC_URL || '';
const serviceImages = [
  `${publicUrl}/images/feasibility.jpg`,
  `${publicUrl}/images/contracts.jpg`,
  `${publicUrl}/images/program.jpg`,
  `${publicUrl}/images/developing.jpg`,
];

const ServicesPage = () => {
  const services = [
    { id: 'feasibility', title: 'Feasibility & Bidding Management', description: 'Building, supporting, monitoring and reviewing feasibility stages (market, technical, financial). Managing primary schedules, bid terms, tender reviews, and technical evaluations.', backgroundImage: serviceImages[0] },
    { id: 'contracts', title: 'Contracts & Claims Management', description: 'Preparing contracting/subcontracting documents, liability identification, damage calculation, and resolving claims through negotiation or arbitration.', backgroundImage: serviceImages[1] },
    { id: 'management', title: 'Program & Project Management', description: 'Developing schedules, manpower plans, and cash flows. Monitoring progress, design review, risk management, and providing regular performance reports.', backgroundImage: serviceImages[2] },
    { id: 'capabilities', title: 'Developing PM Capabilities', description: 'Providing training in project management, human skills, and leadership. Outsourcing, remote services, and enhancing corporate PMOs.', backgroundImage: serviceImages[3] },
  ];

  return (
    <section className="services-page-wrapper">
      <div className="services-page-grid-container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card service-card--bg card"
              style={{ backgroundImage: `url(${service.backgroundImage})` }}
            >
              <div className="service-card-overlay" />
              <div className="service-card-content">
                <h4 className="service-card-title">{service.title}</h4>
                <p className="service-card-desc">{service.description}</p>
                <Link to={`/services/${service.id}`} className="service-btn">Learn More</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
